<div
  class="centered-page-container"
  style="justify-content: center; align-items: center"
>
  <div class="login-bg-image-wrapper">
    <picture>
      <!-- WebP with responsive sizes -->
      <source
        type="image/webp"
        srcset="
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-640w.webp   640w,
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-1024w.webp 1024w,
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-1366w.webp 1366w,
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-1920w.webp 1920w
        "
        sizes="100vw"
      />
      <!-- JPEG fallback with responsive sizes -->
      <source
        type="image/jpeg"
        srcset="
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-640w.jpg   640w,
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-1024w.jpg 1024w,
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-1366w.jpg 1366w,
          https://d1sips1sizw66e.cloudfront.net/gba/images/hero-1920w.jpg 1920w
        "
        sizes="100vw"
      />
      <!-- Default fallback -->
      <img
        class="login-bg-image"
        src="https://d1sips1sizw66e.cloudfront.net/gba/images/hero-1366w.jpg"
        alt="Background"
        width="1671"
        height="940"
        loading="eager"
        fetchpriority="high"
      />
    </picture>
    <div class="login-bg-overlay"></div>
  </div>

  <lib-card
    [title]="'login' | translate"
    [size]="'small'"
  >
    @if (view === 'request-email') {
      <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
      >
        <lib-input
          #emailInput
          type="email"
          formControlName="email"
          [label]="'email' | translate"
          name="email"
          [placeholder]="'emailPlaceholderName' | translate"
          [required]="true"
        />

        @if (showPassword) {
          <lib-input
            #passwordInput
            type="password"
            formControlName="password"
            [label]="'password' | translate"
            name="password"
            [placeholder]="'passwordPlaceholder' | translate"
            [required]="true"
            autocomplete="current-password"
          />
          <a
            [routerLink]="'/forgot-password'"
            class="forgot-password"
            (click)="onForgotPasswordClick()"
          >
            {{ 'forgot-password' | translate }}
          </a>
        }

        <lib-button
          [isLoading]="isLoading"
          [type]="'submit'"
          [fullWidth]="true"
          [disabled]="form.get('email')?.invalid || form.get('password')?.invalid || isLoading"
        >
          {{ showPassword ? ('login' | translate) : ('continue' | translate) }}
        </lib-button>

        <!-- <div class="login-submit-container">
          <a
            [routerLink]="'/register'"
            class="dont-have-an-account"
          >
            <span class="muted">{{ 'dont-have-an-account' | translate }} </span>
            <span class="emphasized">{{ 'register' | translate }}</span>
          </a>
        </div> -->
        <!-- 
        @if (showPassword) {
          <div class="horizontal-separator"></div>

          <lib-button
            variant="text"
            [fullWidth]="true"
            (clicked)="dontUsePassword()"
          >
            {{ 'log-in-without-password' | translate }}
          </lib-button>
        }
          -->
      </form>
    } @else if (view === 'check-email') {
      <div class="check-email-message">
        <p>{{ 'check-email-message' | translate: { email: form.get('email')?.value } }}</p>
      </div>

      <form
        [formGroup]="codeForm"
        (ngSubmit)="onSubmitCode()"
      >
        <div class="code-inputs">
          <input
            #codeInput1
            type="text"
            formControlName="code1"
            name="code1"
            required
            maxlength="1"
            (input)="onCodeInput(1, $event)"
            (keydown)="onKeyDown(1, $event)"
            (paste)="handleCodePaste($event)"
          />
          <input
            #codeInput2
            type="text"
            formControlName="code2"
            name="code2"
            required
            maxlength="1"
            (input)="onCodeInput(2, $event)"
            (keydown)="onKeyDown(2, $event)"
          />
          <input
            #codeInput3
            type="text"
            formControlName="code3"
            name="code3"
            required
            maxlength="1"
            (input)="onCodeInput(3, $event)"
            (keydown)="onKeyDown(3, $event)"
          />
          <input
            #codeInput4
            type="text"
            formControlName="code4"
            name="code4"
            required
            maxlength="1"
            (input)="onCodeInput(4, $event)"
            (keydown)="onKeyDown(4, $event)"
          />
          <input
            #codeInput5
            type="text"
            formControlName="code5"
            name="code5"
            required
            maxlength="1"
            (input)="onCodeInput(5, $event)"
            (keydown)="onKeyDown(5, $event)"
          />
          <input
            #codeInput6
            type="text"
            formControlName="code6"
            name="code6"
            required
            maxlength="1"
            (input)="onCodeInput(6, $event)"
            (keydown)="onKeyDown(6, $event)"
          />
        </div>

        <div class="resend-code-container">
          <lib-button
            (clicked)="requestNewCode()"
            variant="text"
            size="small"
          >
            {{ 'send-new-code' | translate }}
          </lib-button>
        </div>

        <lib-button
          [isLoading]="isLoading"
          [type]="'submit'"
          [fullWidth]="true"
          [disabled]="codeForm.invalid || isLoading"
        >
          {{ 'login' | translate }}
        </lib-button>

        <div class="horizontal-separator"></div>

        <lib-button
          variant="text"
          [fullWidth]="true"
          (clicked)="usePassword()"
        >
          {{ 'log-in-with-password' | translate }}
        </lib-button>
      </form>
    }
  </lib-card>
</div>
